
import {
  Card, CardContent, CardActions, Stack, Typography, Chip, Button, Box//, IconButton
} from "@mui/material";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
// import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
// import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
// import { parseLieu, normalizeContact, Club } from "../lib/judo-utils";
import type { UniClub as Club } from "../types";

/**
 * Case au style de la maquette:
 * - bandeau de discipline discret
 * - grand titre en MAJUSCULES
 * - lieu en chip rouge avec épingle
 * - email en pilule bleue
 * - pastille circulaire à droite (globe/téléphone)
 */
export default function ClubCardModern({ club }: { club: Club }) {
//   const { ville, departement } = parseLieu(club.lieu);
//   const contact = normalizeContact(club.site);

  // Couleurs locales
  const COLOR_PRIMARY = "primary";   // pastilles bleues
  const COLOR_SECOND = "secondary";  // chip lieu rouge

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 4,                        // arrondi (overrides theme if needed)
        borderColor: "rgba(26,31,162,0.15)",    // léger bleu
        boxShadow: "none",
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          {/* Colonne gauche : contenu */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {/* Discipline (bandeau discret) */}
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
              <Box sx={{ width: 28, height: 4, bgcolor: "primary.main", borderRadius: 2 }} />
              <Typography
                variant="caption"
                sx={{ letterSpacing: 1, color: "text.secondary", fontWeight: 700 }}
              >
                {club.discipline?.toUpperCase()}
              </Typography>
            </Stack>

            {/* Nom en gros, majuscules */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                textTransform: "uppercase",
                color: "text.primary",
                lineHeight: 1.15,
                mb: 1.25,
                wordBreak: "break-word",
              }}
            >
              {club.nom}
            </Typography>

            {/* Lieu en chip rouge */}
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.25 }}>
              <LocationOnRoundedIcon sx={{ color: "secondary.main" }} fontSize="small" />
              <Chip
                color={COLOR_SECOND}
                size="small"
                label={
                  club.lieu
                }
                sx={{
                  color: "#fff",
                  "& .MuiChip-label": { fontWeight: 700, letterSpacing: 0.2 },
                }}
              />
            </Stack>

            {/* Email en pilule bleue (si dispo) */}
            {club.email && (
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailRoundedIcon sx={{ color: "primary.main" }} fontSize="small" />
                <Button
                  variant="contained"
                  color={COLOR_PRIMARY}
                  size="small"
                  href={`mailto:${club.email}`}
                  startIcon={null}
                  sx={{
                    borderRadius: 999,
                    textTransform: "none",
                    fontWeight: 800,
                    letterSpacing: 0.2,
                    px: 1.5,
                    minHeight: 28,
                    fontSize: "0.605rem",
                    // minWidth: 250
                  }}
                >
                  {club.email.toUpperCase()}
                </Button>
              </Stack>
            )}
          </Box>

          {/* Colonne droite : pastille circulaire (site/tel) */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <IconButton
              aria-label={contact?.kind === "tel" ? "Téléphone" : "Site web"}
              href={contact ? contact.value : undefined}
              target={contact?.kind === "web" ? "_blank" : undefined}
              rel={contact?.kind === "web" ? "noopener noreferrer" : undefined}
              sx={{
                bgcolor: "primary.main",
                color: "#fff",
                width: 44,
                height: 44,
                "&:hover": { bgcolor: "primary.dark" },
              }}
            >
              {contact?.kind === "tel" ? (
                <PhoneIphoneRoundedIcon />
              ) : (
                <PublicRoundedIcon />
              )}
            </IconButton> */}
          </Box>
        </Stack>
      </CardContent>

      {/* Ligne séparatrice légère + padding bas (optionnel pour l'aspect “carte”) */}
      <CardActions sx={{ px: 2.5, pb: 2.5 }} />
    </Card>
  );
}
